import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const BackContainer = styled.div`
  min-width: 36px;
`
